/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface MessageDeliveryStatusDto { 
    senderId?: string;
    rateCost?: string;
    message?: string;
    destinationNumber?: string;
    dateSent: Date;
    status?: string;
    referenceNumber?: string;
    stateChangeReason?: string;
    stateChangeUtc?: Date;
    messageId?: string;
}
